"use strict";

exports.__esModule = true;
exports["default"] = exports.LoadingRotateKeyframes = exports.LoadingIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingRotateKeyframes = (0, _styledComponents.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(359deg);}"]);
exports.LoadingRotateKeyframes = LoadingRotateKeyframes;

var LoadingIcon = _styledComponents["default"].div.withConfig({
  displayName: "loading-indicator__LoadingIcon",
  componentId: "sc-bazile-0"
})(["width:40px;height:40px;border-bottom-color:", ";border-left-color:", ";border-right-color:", ";border-top-color:", ";border-radius:100%;border-style:solid;border-width:2.5px;content:\"\";transform-origin:center center;transition:opacity 0.5s ", "};animation:", " 0.6s linear infinite;"], function (props) {
  return (0, _styles.themeTransparentize)(0.8, "text-mid", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.8, "text-mid", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.8, "text-mid", props);
}, function (props) {
  return (0, _styles.colors)("blue", props);
}, _styles.defaultEase, LoadingRotateKeyframes);

exports.LoadingIcon = LoadingIcon;
var propTypes = {
  /** Class name for the LoadingIndicator */
  className: _propTypes.string,

  /** object that contains specific styles for the LoadingIndicator */
  style: (0, _propTypes.shape)({})
};
var defaultProps = {
  style: {}
};
/**
 * Loading Indicator is a generic component used to signify waiting for an api request.
 * The animations are handled with css.
 */

var LoadingIndicator = function LoadingIndicator(_ref) {
  var className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement(LoadingIcon, {
    className: className,
    style: style
  });
};

LoadingIndicator.defaultProps = defaultProps;
LoadingIndicator.propTypes = propTypes;
var _default = LoadingIndicator;
exports["default"] = _default;